import "../App.css";
export const Footer = () => {
    return (
        <div className="footer">
            <p>Copyright &copy; 2026 DATY ABAYA'S. All rights reserved.</p>
        </div>
    );
};